import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/submitted-review.png'


const _withScopeId = n => (_pushScopeId("data-v-8c4ef20e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 no-review-container d-flex justify-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "This Tenant Doesn't Have A Review Yet")
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}